import { createListenerMiddleware } from '@reduxjs/toolkit';

import { logger } from '@/components/SgwtBootstrap/logger.ts';
import type { AppDispatch, AppState } from '@/store/store.ts';

export const listenerMiddleware = createListenerMiddleware({
  onError: (error, errorInfo) => {
    logger.logError(
      'Error in redux listener {raisedBy_s}: {errorMessage_s} {errorStack_s}',
      errorInfo.raisedBy,
      error instanceof Error ? error.message : String(error),
      error instanceof Error ? error.stack : undefined,
    );
  },
});

export const startAppListening = listenerMiddleware.startListening.withTypes<AppState, AppDispatch>();
export type StartAppListening = typeof startAppListening;
